/**
 * BoardUser.workforce_app_installs helpers (loadsync + sockets).
 * Nested install keys stay snake_case from the API.
 */

export type WorkforceAppInstall = {
  device_id?: string;
  app_version?: string | null;
  device_model?: string | null;
  last_seen_at?: string | null;
};

export function sortWorkforceAppInstalls(
  installs: WorkforceAppInstall[] | null | undefined,
): WorkforceAppInstall[] {
  if (!Array.isArray(installs) || installs.length === 0) return [];
  return [...installs].sort((a, b) => {
    const aTs = a?.last_seen_at ? new Date(a.last_seen_at).getTime() : 0;
    const bTs = b?.last_seen_at ? new Date(b.last_seen_at).getTime() : 0;
    return bTs - aTs;
  });
}

export function formatWorkforceAppInstallLabel(
  install: WorkforceAppInstall | null | undefined,
): string {
  if (!install) return "";
  const version = install.app_version?.trim?.() || install.app_version || "";
  const model = install.device_model?.trim?.() || install.device_model || "";
  if (version && model) return `${version} · ${model}`;
  return version || model || "";
}

/**
 * Cell / summary string for the Users grid.
 * Returns null when there is nothing to show (no installs, no Workforce interaction).
 */
export function formatWorkforceAppInstallsCell(
  installs: WorkforceAppInstall[] | null | undefined,
  lastInteractionWorkforce: string | Date | null | undefined,
): string | null {
  const sorted = sortWorkforceAppInstalls(installs);
  if (sorted.length > 0) {
    return sorted
      .map((install) => formatWorkforceAppInstallLabel(install))
      .filter(Boolean)
      .join(" · ") || null;
  }
  if (lastInteractionWorkforce) return "Unknown build";
  return null;
}
